import { TextField, TextFieldProps } from '@mui/material';
import { ChangeEvent } from 'react';

type StringListFieldProps = TextFieldProps & {
  separator: string;
};

export default function StringListField(props: StringListFieldProps) {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const arr = event.target.value.split(',').map(w => w.trim()) as unknown;
    props.onChange?.({
      ...event,
      ...{
        target: {
          ...event.target,
          value: arr as any,
        },
      },
    });
  };

  return <TextField {...props} onChange={handleChange} />;
}
